import { createTestListOperations } from '../../../common/test-list/operations';
import filterOperations from '../../filters/operations';
import filterActions from '../../filters/actions';
import { STORAGE_TESTS_RDC_KEY, TEST_HISTORY_PATH, TEST_HISTORY_CLOUD_KEY } from '../../../../constants';
import actions from './actions';
import * as selectors from './selectors';

const operations = {};
export default Object.assign(
  operations,
  createTestListOperations({
    actions,
    selectors,
    operations,
    filterOperations,
    filterActions,
    statusStoreKey: STORAGE_TESTS_RDC_KEY,
    type: 'rdc',
    pathPattern: TEST_HISTORY_PATH,
    cloudTypeKey: TEST_HISTORY_CLOUD_KEY,
  }),
);
